import { type Filter, FilterId, FilterType } from '../../types/filters';
import type { CustomSkillTreeNode } from '../skillTaxonomyTree';

export const isCompositionV3CustomSkillTaxonomyReady = ({
  effectiveFilters,
  customSkillTree,
  isCustomSkillLevelMapReady,
  isCustomSkillTaxonomyPending = false,
}: {
  effectiveFilters: Filter[];
  customSkillTree: CustomSkillTreeNode[] | null;
  isCustomSkillLevelMapReady: boolean;
  /** True while skill taxonomy / level map is still loading (reference API or legacy list). */
  isCustomSkillTaxonomyPending?: boolean;
}): boolean => {
  const hasCustomSkillSelections = effectiveFilters.some(
    (f) =>
      f.id === FilterId.CUSTOM_SKILL &&
      f.type === FilterType.TREE &&
      f.selections.length > 0
  );

  if (!hasCustomSkillSelections) {
    return true;
  }

  if (isCustomSkillTaxonomyPending || !isCustomSkillLevelMapReady) {
    return false;
  }

  return Array.isArray(customSkillTree) && customSkillTree.length > 0;
};
